import type {ValidationMessageTemplate} from "@vee-validate/i18n"

export default {
    messages: {
        verify_password: "Password is not strong enough. Please use a different password",
        confirm_password: "The passwords do not match",
        verify_url: "URL is invalid",
        validation_pending: "Verifying...",
        editor_content_required: "{field} is required",
        puzzle_unsolved: "This puzzle is still unsolved...",
        juleica_card_number_doesnt_match_with_contact: "{_value_} is a valid card number but doesn't match the contact data.",
        juleica_invalid: "{_value_} is not a valid Juleica card number or has already expired.",
        iban_invalid: "Your IBAN is invalid. Please check your entered IBAN.",
        phone_invalid: "The phone number format is invalid. Only numbers and the + symbol are allowed. A valid number would be e.g.: +49 711 XXXXXX.",
        includes: "The input must contain 0:{text}.",
        valid_date: "The entered value is not a valid date. Preferably use the format DD.MM.YYYY or YYYY-MM-DD.",
        date_is_after: "The entered date is not valid.",
        date_is_before: "The entered date is not valid.",
        is_regex: "Input is not a valid regular expression.",
        deeply_nested: "Invalid state! Group questions must not be nested.",
    }
} as {
    messages: Record<string, ValidationMessageTemplate>
}